import { Color } from "@evergis/color";

export const getHexColor = (colorString: string): string | undefined =>
  colorString ? new Color(colorString).toString("hex") : undefined;

export const transparentizeColor = (originalColor: string, percent: number): string => {
  const color = new Color(originalColor);

  color.a = Math.round((255 / 100) * percent);

  return color.toString("hex");
};

export function hexToRGB(hex: string, alpha: number): string {
  const red = parseInt(hex.slice(1, 3), 16);
  const green = parseInt(hex.slice(3, 5), 16);
  const blue = parseInt(hex.slice(5, 7), 16);

  if (alpha) {
    return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
  }

  return `rgb(${red}, ${green}, ${blue})`;
}

export function colorAlpha(color: string, alpha: number): string {
  let newColor;

  if (color.includes("rgb")) {
    newColor = color.replace(" ", "");
    const value = /\(([^)]+)\)/.exec(newColor);
    const values = value?.[1]?.split(",");

    newColor = `rgba(${values?.[0]},${values?.[1]},${values?.[2]},${alpha})`;
  } else {
    newColor = hexToRGB(color, alpha);
  }

  return newColor;
}
